import { render, staticRenderFns } from "./retrievePwdNew.vue?vue&type=template&id=9595a992&scoped=true"
import script from "./retrievePwdNew.vue?vue&type=script&lang=js"
export * from "./retrievePwdNew.vue?vue&type=script&lang=js"
import style0 from "./retrievePwdNew.vue?vue&type=style&index=0&id=9595a992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9595a992",
  null
  
)

export default component.exports